import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListingDataSource, ListingPayload } from '@portal/shared/types/listing.types';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import { AlarmsService } from '../services/alarm-data.service';
import { AlarmsTable } from '../services/alarm-data.types';
import { AlarmListingFieldName } from '../services/alarms.types';

@Injectable()
export class AlarmsListingDataSourceService implements ListingDataSource<AlarmsTable> {
  private readonly alarmsService = inject(AlarmsService);
  private readonly tz = inject(TimezoneService);

  total = 0;

  getAll(tableState: ListingPayload): Observable<AlarmsTable> {
    return this.alarmsService.prepareDataForTable({
      ...tableState,
      filters: [
        ...(tableState.filters ?? []).map(f => ({
          ...f,
          filteredValues:
            f.filterType === AlarmListingFieldName.DateTimeUtcUpdated
              ? this.tz.getShiftedDatepickerRangeStringified({
                  start: new Date(f.filteredValues[0]),
                  end: new Date(f.filteredValues[1])
                })
              : f.filteredValues
        }))
      ]
    });
  }
}
